var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdcErc20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1096_524)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1096_524",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H0V45H45V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1096_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#3E73C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1569 25.4862C28.1569 22.4994 26.3569 21.4757 22.7569 21.0482C20.1863 20.7064 19.6731 20.0244 19.6731 18.8291C19.6731 17.6337 20.5308 16.8659 22.2436 16.8659C23.7863 16.8659 24.6441 17.3779 25.0716 18.6589C25.1162 18.7828 25.1976 18.89 25.305 18.9662C25.4123 19.0423 25.5404 19.0839 25.6721 19.085H27.0431C27.1224 19.0871 27.2012 19.0732 27.2748 19.0439C27.3485 19.0147 27.4153 18.9707 27.4714 18.9149C27.5277 18.8589 27.5719 18.7922 27.6014 18.7187C27.6311 18.6453 27.6453 18.5665 27.6436 18.4874V18.4029C27.4761 17.4761 27.0071 16.6305 26.3096 15.9976C25.6121 15.3647 24.7251 14.9798 23.7863 14.9029V12.8553C23.7863 12.5136 23.529 12.2577 23.1015 12.1719H21.8148C21.4731 12.1719 21.2156 12.4278 21.1299 12.8553V14.8184C18.5579 15.1587 16.9308 16.8659 16.9308 19.0007C16.9308 21.8159 18.6436 22.9254 22.2436 23.3529C24.6441 23.7791 25.4148 24.2924 25.4148 25.6579C25.4148 27.0219 24.2153 27.9612 22.5868 27.9612C20.3579 27.9612 19.5873 27.0232 19.3299 25.7422C19.2456 25.4019 18.9868 25.2304 18.7294 25.2304H17.2726C17.1934 25.2284 17.1148 25.2425 17.0414 25.2718C16.9679 25.3012 16.9012 25.3451 16.8452 25.401C16.7892 25.4568 16.7452 25.5235 16.7156 25.5969C16.6861 25.6703 16.6718 25.7489 16.6736 25.8279V25.9124C17.0153 28.047 18.3878 29.5827 21.2156 30.0102V32.0591C21.2156 32.3994 21.4731 32.6567 21.9006 32.7411H23.1873C23.529 32.7411 23.7863 32.4852 23.8721 32.0591V30.0087C26.4441 29.5827 28.1569 27.791 28.1569 25.4862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1297 34.449C11.4444 32.0583 8.01595 24.6333 10.5022 18.0618C11.7875 14.476 14.6155 11.7464 18.1297 10.4653C18.4728 10.2952 18.643 10.0392 18.643 9.61172V8.4164C18.643 8.0761 18.4728 7.82015 18.1297 7.73438C18.0439 7.73438 17.8724 7.73437 17.7865 7.81875C15.8577 8.42107 14.0673 9.39899 12.5179 10.6962C10.9687 11.9934 9.6913 13.5842 8.75936 15.3772C7.82742 17.17 7.25935 19.1295 7.08783 21.1429C6.91633 23.1562 7.14477 25.1836 7.76002 27.1083C9.30127 31.8895 12.987 35.5598 17.7865 37.0955C18.1297 37.2656 18.4728 37.0955 18.5572 36.7538C18.643 36.6693 18.643 36.5822 18.643 36.412V35.2167C18.643 34.9608 18.387 34.6205 18.1297 34.449ZM27.214 7.82015C26.871 7.6486 26.5278 7.82015 26.4435 8.16047C26.3577 8.24625 26.3577 8.33203 26.3577 8.50219V9.6975C26.3577 10.0392 26.6137 10.3795 26.871 10.5511C33.5562 12.9417 36.9847 20.3667 34.4985 26.9382C33.2132 30.524 30.3852 33.2535 26.871 34.5347C26.5278 34.7048 26.3577 34.9608 26.3577 35.3883V36.5835C26.3577 36.924 26.5278 37.1798 26.871 37.2656C26.9567 37.2656 27.1283 37.2657 27.214 37.1813C29.1428 36.5789 30.9334 35.601 32.4827 34.3038C34.0319 33.0066 35.3094 31.4158 36.2413 29.6228C37.1732 27.83 37.7412 25.8705 37.9128 23.8571C38.0843 21.8438 37.8559 19.8164 37.2407 17.8917C35.6994 13.0261 31.9278 9.35578 27.214 7.82015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7353 45.0001C40.8521 45.0001 45 40.8522 45 35.7354C45 30.6186 40.8521 26.4707 35.7353 26.4707C30.6185 26.4707 26.4706 30.6186 26.4706 35.7354C26.4706 40.8522 30.6185 45.0001 35.7353 45.0001Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 28.7871V33.9232L40.3646 35.863L36.0236 28.7871Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0237 28.7871L31.682 35.863L36.0237 33.9232V28.7871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 39.1909V42.6808L40.3675 36.6709L36.0236 39.1909Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0237 42.6808V39.1904L31.682 36.6709L36.0237 42.6808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 38.384L40.3646 35.8635L36.0236 33.9248V38.384Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.682 35.8635L36.0237 38.384V33.9248L31.682 35.8635Z",
    fill: "white",
    fillOpacity: 0.602
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1096_524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdcErc20);
export default __webpack_public_path__ + "static/media/usdc_erc_20.ab107a9575680e204893e4f0e56a3dd1.svg";
export { ForwardRef as ReactComponent };